import React, { Component } from 'react'
import Helmet from 'react-helmet'

import Header from '../../components/Header'
import Footer from '../../components/core/Footer'
import ApplyFranchiseComponent from '../../components/ApplyFranchiseComponent'
import darkTheme from '../../constants/themeConstants/darkTheme'
import bookNowConstants from '../../constants/bookNowFormConstants'

class IbcFranchise extends Component {
  constructor(props) {
    super(props)
    this.state = {
      glsLoaded: false
    }
  }
  initMap = () => {
    this.setState({
      glsLoaded: true
    })
  }
  loadGooglePlacesScript() {
    try {
      window.initMap = this.initMap
      const gmapScriptEl = document.createElement(`script`)
      gmapScriptEl.src = bookNowConstants.GOOGLE_SCRIPT_URL
      document
        .querySelector(`body`)
        .insertAdjacentElement(`beforeend`, gmapScriptEl)
    } catch (error) {
      console.log(error)
    }
  }

  componentDidMount() {
    if (!window.google) {
      this.loadGooglePlacesScript()
    }
    if (window.google) {
      this.initMap()
    }
  }

  render() {
    const { glsLoaded } = this.state
    const { data } = this.props
    const {
      applyForFranchiseSEOData: { edges: seoData },
      applyForFranchiseData: { edges: formData },
      formDropDownList: { edges: formDropDownList }
    } = data
    const {
      occupationListDropDownValues
    } = formDropDownList[0].node.frontmatter
    const {
      headerPropsData,
      footerProps,
      isBookNowSlotOpened,
      bookNowModalData
    } = this.props
    const {
      title,
      metaDescription,
      ogTitle,
      ogWebsiteUrl,
      ogImageUrl,
      ogDescription,
      ogType,
      ogSiteName,
      twitterCard,
      twitterUrl,
      twitterSite,
      twitterTitle,
      twitterDescription,
      twitterImage
    } = seoData[0].node.frontmatter
    return (
      <div>
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={metaDescription} />
          <meta property="og:title" content={ogTitle} />
          <meta property="og:url" content={ogWebsiteUrl} />
          <meta property="og:image" content={ogImageUrl} />
          <meta property="og:description" content={ogDescription} />
          <meta property="og:type" content={ogType} />
          <meta property="og:site_name" content={ogSiteName} />
          <meta name="twitter:card" content={twitterCard} />
          <meta property="twitter:title" content={twitterTitle} />
          <meta name="twitter:url" content={twitterUrl} />
          <meta name="twitter:site" content={twitterSite} />
          <meta property="twitter:description" content={twitterDescription} />
          <meta name="twitter:image" content={twitterImage} />
          <meta name="robots" content="noindex" />
        </Helmet>
        <Header
          headerPropsData={headerPropsData}
          isBookNowSlotOpened={isBookNowSlotOpened}
          bookNowModalData={bookNowModalData}
          isFranchisePage
        />
        <ApplyFranchiseComponent
          formData={formData}
          glsLoaded={glsLoaded}
          occupationListDropDownValues={occupationListDropDownValues}
          hideSubHeading
        />
        <Footer {...footerProps} theme={darkTheme.footerSection} />
      </div>
    )
  }
}

export default IbcFranchise

// eslint-disable-next-line
export const graphqlQuery = graphql`
  query ApplyForFranchisePageQuery {
    applyForFranchiseSEOData: allMarkdownRemark(
      filter: {
        fileAbsolutePath: { regex: "/content/viu/seo-ibc-apply-franchise/" }
      }
    ) {
      edges {
        node {
          frontmatter {
            title
            metaDescription
            ogTitle
            ogWebsiteUrl
            ogImageUrl
            ogDescription
            ogType
            ogSiteName
            twitterCard
            twitterUrl
            twitterSite
            twitterTitle
            twitterDescription
            twitterImage
          }
        }
      }
    }

    applyForFranchiseData: allMarkdownRemark(
      filter: {
        fileAbsolutePath: { regex: "/content/viu/ibc-apply-franchise-data/" }
      }
    ) {
      edges {
        node {
          frontmatter {
            title
            pageHeading
            pageSubHeading
            formHeading
            nameFieldPlaceholder
            emailFieldPlaceholder
            phoneNumberFieldPlaceholder
            occupationFieldPlaceholder
            locationFieldPlaceHolder
            ctaButtonText
            thankYouTextOne
            thankYouTextTwo
          }
        }
      }
    }
    formDropDownList: allMarkdownRemark(
      filter: {
        fileAbsolutePath: {
          regex: "/content/formDropDownLists/OccupationList/"
        }
      }
      sort: { fields: [frontmatter___order], order: ASC }
    ) {
      edges {
        node {
          frontmatter {
            occupationListDropDownValues {
              label
              value
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/franchise/index.js